module.exports = __webpack_public_path__ + "static/media/splash.83852dab.png";